/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DashboardDefinitionToPortal {
    getFixupPrototypeFunction() { return DashboardDefinitionToPortal.fixupPrototype; }

    static newInstance(model: Partial<DashboardDefinitionToPortal>): DashboardDefinitionToPortal {
        let obj = Object.assign(new DashboardDefinitionToPortal(), model);
        DashboardDefinitionToPortal.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DashboardDefinitionToPortal>): DashboardDefinitionToPortal {
        if (!model) return null;
        return DashboardDefinitionToPortal.newInstance(<DashboardDefinitionToPortal> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DashboardDefinitionToPortal) {
        if (!obj) return;

        models.DashboardDefinitionToPortal.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DashboardDefinitionToPortal): boolean {
        Object.setPrototypeOf(obj, DashboardDefinitionToPortal.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    dashboard_id: string;

    portalPath: Array<string>;

}
